import React from 'react';

// material-ui
import {
    IconButton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

// project import
import DeleteAlert from './DeleteAlert';
import ColoredDropdown from 'views/User/SimpleSpeedDials';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';
import { USER_STATUS } from 'store/constant';

export default function PriceList({ rows, handleClickOpen, setReload }) {

    const changeStatus = (rowuuid) => {
        changeVenueStatusApi.execute(rowuuid);
    };

    const changeStatusHandler = () => {
        setReload(r => !r);
    };

    const changeVenueStatusApi = useApi(VenueService.changePriceStatusByUuid, changeStatusHandler, true);

    return (
        <>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ pl: 3 }}>#</TableCell>
                            <TableCell>Sports Type</TableCell>
                            <TableCell>Weekday Price</TableCell>
                            <TableCell>Weekend Price</TableCell>
                            <TableCell>Holiday Price</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell align="center" sx={{ pr: 3 }}>
                                Actions
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows.map((row, index) =>
                                <TableRow hover key={index}>
                                    <TableCell sx={{ pl: 3 }}>{index + 1}</TableCell>
                                    <TableCell>{row.display_name}</TableCell>
                                    <TableCell>{row.weekday_price}</TableCell>
                                    <TableCell>{row.weekend_price}</TableCell>
                                    <TableCell>{row.holiday_price}</TableCell>
                                    <TableCell>
                                        <ColoredDropdown
                                            itemArray={USER_STATUS}
                                            selectedValue={row.is_active}
                                            rowUuid={row.uuid}
                                            handleChange={changeStatus}
                                        />
                                    </TableCell>
                                    <TableCell align="center" sx={{ pr: 3 }}>
                                        <Stack direction="row" justifyContent="center" alignItems="center">
                                            <Tooltip placement="top" title="Edit">
                                                <IconButton
                                                    color="primary"
                                                    aria-label="delete"
                                                    size="large"
                                                    onClick={() => handleClickOpen(row.uuid)}
                                                >
                                                    <EditIcon sx={{ fontSize: '1.1rem' }} />
                                                </IconButton>
                                            </Tooltip>
                                            <DeleteAlert setReload={setReload} priceUuid={row.uuid} />
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer >
        </>
    );
};